import React from "react";
import { MusicStatsView } from "./MusicStatsView";
import { useGetAllMusicStatsForOrganization } from "./hooks/useGetAllMusicStatsForOrganization";
import { useGetDownloadMusicStatisticsForOrganization } from "./hooks/useGetDownloadMusicStatisticsForOrganization";
import routeNames from "../../constants/routeNames";
import { useHistory } from "react-router-dom";
import i18n from "../../constants/i18n";

interface MusicStatsContainerProps {
    organizationId: number;
}

export function OrganizationMusicStatsContainer(
    props: MusicStatsContainerProps
) {
    const history = useHistory();

    const musicStats = useGetAllMusicStatsForOrganization(props.organizationId);
    const isLoading = musicStats && musicStats.isLoading;
    const data = musicStats && musicStats.data;
    const musicStatsDownload = useGetDownloadMusicStatisticsForOrganization(
        props.organizationId
    );

    const locationId = props.organizationId;

    const backToOverview = () => {
        history.push(`${routeNames.locations}/`);
    };

    return (
        <MusicStatsView
            isLoading={isLoading}
            data={data}
            musicStatsDownload={musicStatsDownload}
            locationId={locationId}
            onBackToOverviewClick={backToOverview}
            title={i18n.generic.OrganzationMusicTop10}
        />
    );
}
